import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import IncentivesList from './IncentivesList'

export default function Incentives() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/incentives" component={IncentivesList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}